import { useApolloClient } from '@apollo/client';
import { useCallback } from 'react';
import {
  DocumentDownloadLink,
  DocumentDownloadLinkVariables,
} from './__generated__/DocumentDownloadLink';

import DOCUMENT_DOWNLOAD_LINK from './DocumentDownloadLink.graphql';

export default function useDownloadLink() {
  const client = useApolloClient();

  const getLink = useCallback(
    async (entityDocumentId: string, options?: { userRequested?: boolean }) => {
      const res = await client.query<
        DocumentDownloadLink,
        DocumentDownloadLinkVariables
      >({
        query: DOCUMENT_DOWNLOAD_LINK,
        variables: {
          documentId: entityDocumentId,
          userRequested: options?.userRequested,
        },
        fetchPolicy: 'network-only',
      });

      return res.data.entityDocument?._downloadLink;
    },
    [client]
  );

  return getLink;
}

